import {useState, useEffect, useRef, createRef} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';

export default ({fill, size, value, style}) => {
    const [copied, setCopied] = useState(false),
          none_copied = createRef(),
          yes_copied = createRef();

    useEffect(() => {
        if(copied)
            window.copy_timeout = setTimeout(() => {
                setCopied(false);
            }, 2e3);

        return () => clearTimeout(window.copy_timeout);
    }, [copied]);

    return (
        <CopyToClipboard text={value} onCopy={e => {
            setCopied(true);
        }}>
            <div className="copy" style={style}>
                {!copied ? (
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width: size}} ref={none_copied}>
                        <path d="M12 9.675V12.825C12 15.45 10.95 16.5 8.325 16.5H5.175C2.55 16.5 1.5 15.45 1.5 12.825V9.675C1.5 7.05 2.55 6 5.175 6H8.325C10.95 6 12 7.05 12 9.675Z" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.5 5.175V8.325C16.5 10.95 15.45 12 12.825 12H12V9.675C12 7.05 10.95 6 8.325 6H6V5.175C6 2.55 7.05 1.5 9.675 1.5H12.825C15.45 1.5 16.5 2.55 16.5 5.175Z" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                ) : (
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width: size}} ref={yes_copied}>
                        <path d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.8125 8.99994L7.935 11.1224L12.1875 6.87744" stroke={fill} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                )}
            </div>
        </CopyToClipboard>
    )

}